import { Address } from "ton";

export function toTonConnectAddress(address: Address | string): string {
  const parsedAddress = typeof address === "string" ? Address.parse(address) : address;

  return parsedAddress.toFriendly({ urlSafe: true, bounceable: true });
}
